import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Form } from '@unform/web';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Spinner } from '~/components';
import { Autocomplete, DateTime } from '~/components/Form';
import { t } from '~/helpers';
import { validation, validationErrors } from '~/helpers/yupValidations';
import { updateData } from '~/store/modules/EdicaoOperacao/AlinhamentoTanque/actions';

export default function FormUpdate({ reference, data }) {
  const { loading, find, params } = useSelector(
    (state) => state.edicaoAlinhamentoTanque
  );

  const dispatch = useDispatch();
  const initials = { ...find, ...data };

  const handleSubmit = useCallback(
    async (formData) => {
      try {
        const schema = Yup.object().shape({
          idtanquefisicodestino: Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .typeError(t('s.geral.validacao.campoobrigatorio')),
        });

        await validation(schema, formData);

        const form = {
          ...find,
          idalinhamentotanquefisico: find.idalinhamentotanquefisicodestino,
          idtanquefisicoanterior: find.idtanquefisicodestino,
          idtanquefisiconovo: formData.idtanquefisicodestino,
        };

        const url = `${find.idalinhamentotanquefisicodestino}/${find.idposto}/${find.idtanquefisicodestino}/${formData.idtanquefisicodestino}`;

        dispatch(updateData(form, params, url));
        console.log('form', form);
      } catch (err) {
        validationErrors(err, reference);
      }
    },
    [reference, find, params]
  );

  // Loading data
  if (loading)
    return (
      <div style={{ height: '14rem', width: '50rem' }}>
        <Spinner loading />
      </div>
    );

  // Form
  return (
    <Form ref={reference} initialData={initials} onSubmit={handleSubmit}>
      <Autocomplete
        disabled
        name="idposto"
        label="codigonomeposto"
        url="postoscomboios"
        unique="idposto"
        title={t('s.relatorio.geral.unidade')}
      />

      <DateTime
        time
        disabled
        name="datahorainicioalinhamentotanquefisico"
        label={t('s.operacao.transferencia.datahorainicialmovimentacao')}
      />

      <Autocomplete
        disabled
        name="idtanquevirtual"
        label="tanquevirtualprodutotanquevirtual"
        url="tanquesvirtuais"
        unique="idtanquevirtual"
        title={t('s.relatorio.geral.unidade')}
      />

      <Autocomplete
        name="idtanquefisicodestino"
        label="codigotanquefisico"
        url="tanquesfisicos"
        unique="idtanquefisico"
        title={t('s.menu.configuracao.tanquefisico')}
        params={{
          wherefield: ['idposto', 'idtanquevirtual', 'statustanquefisico'],
          valuewherefield: [find.idposto, find.idtanquevirtual, 'L'],
          typewherefield: ['EQUALS', 'EQUALS', 'EQUALS'],
        }}
      />
    </Form>
  );
}

FormUpdate.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};
